import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

/**
 * IMPORTANT: An ISO date-only string ("yyyy-MM-dd") is not compatible with these functions,
 * since the Javascript's "new Date" will parse to UTC time while the function "format" of date-fns
 * works in local time zone.
 */

export function formatDate(date) {
    return format(new Date(date), "dd MMMM yyyy");
}

export function formatDateISO(date) {
    return format(new Date(date), "yyyy-MM-dd");
}

export function formatDateTime(date) {
    return format(new Date(date), "yyyy-MM-dd HH:mm:ss");
}

export function formatDateTimeUTC(date) {
    return formatInTimeZone(new Date(date), "UTC", "yyyy-MM-dd HH:mm:ss");
}

export function formatDateMonthYearOnly(date) {
    return format(new Date(date), "MM/yyyy");
}

export function monthCountBetween(startDate, endDate) {
    return (
        endDate.getMonth() -
        startDate.getMonth() +
        12 * (endDate.getFullYear() - startDate.getFullYear()) +
        1
    );
}

export function formatDateTimeShort(date) {
    return format(new Date(date), "MM-dd HH:mm");
}

export function offset(utcTime, add) {
    const tzoffset = utcTime.getTimezoneOffset() * 60000;
    const localTime = add
        ? new Date(utcTime.getTime() + tzoffset)
        : new Date(utcTime.getTime() - tzoffset);
    return localTime;
}

export function formatDurationHMS(startDatetime, endDatetime) {
    const start = new Date(startDatetime);
    const end = new Date(endDatetime);
    const diffMs = end - start;

    const hours = Math.floor(diffMs / 3600000);
    const minutes = Math.floor((diffMs % 3600000) / 60000);
    const seconds = Math.floor((diffMs % 60000) / 1000);
    const milliseconds = diffMs % 1000;

    const ms = String(milliseconds).padStart(3, "0");

    if (hours > 0) {
        return `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}.${ms}`;
    }

    return `${minutes}:${String(seconds).padStart(2, "0")}.${ms}`;
}

export const formatSeconds = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
        return `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    }
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};
